import React from 'react'
import { css } from '@emotion/core'
import FixedWidthHubspotForm from 'src/components/hubspot/FixedWidthHubspotForm'
import PardotForm from 'src/components/pardot/PardotForm'

type Props = {
  hsFormId?: string
  formSrc?: string
  type?: string
}

const pardotFormCss = css`
  margin-bottom: 100px;
`

// TODO: HubSpotからPardotに完全移行したら分岐を消し、PardotFormだけを利用する形にする
const PaperForm = ({ hsFormId, formSrc, type }: Props) =>
  type && type === 'pardot' ? (
    <PardotForm css={pardotFormCss} src={formSrc} />
  ) : (
    <FixedWidthHubspotForm style={{ margin: '100px auto' }} formId={hsFormId} />
  )

export default PaperForm
